import styled from "styled-components";

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`;

export const SlideoutHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BackButton = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border-radius: 8px;
  outline: none;

  &:focus-visible {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.15);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
`;

export const SlideoutContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 16px;
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledForm = styled.div`
  .custom-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  /* Override RJSF default margins and styling */
  .rjsf {
    /* Remove default fieldset styling */
    fieldset {
      border: none;
      margin: 0;
      padding: 0;
    }

    /* Remove default legend styling */
    legend {
      display: none;
    }

    /* Global form group styling */
    .form-group {
      margin-bottom: 0;
    }

    /* Add spacing between form groups */
    .form-group + .form-group {
      margin-top: 24px;
    }

    /* Ensure proper spacing for form controls */
    .form-control {
      margin-bottom: 0;
    }

    /* Show labels for specific widget types that need them */
    .form-group.show-label label {
      display: block;
    }
  }

  /* Apply form-field class styling to all form groups */
  .rjsf .form-group {
    margin-bottom: 0;

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
`;

